'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { createGetMediaBridgeObjectsByIds, createGetMediaBridgeObjectsPage, getMediaBridgeObjectsPage, getMediaBridgeObjectsByIds } from '../api/MediaBridgeAPI';
export const createMediaBridgeReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: 'MEDIA_BRIDGE',
  createFetchByIds: createGetMediaBridgeObjectsByIds,
  createFetchSearchPage: createGetMediaBridgeObjectsPage,
  fetchByIds: getMediaBridgeObjectsByIds,
  fetchSearchPage: getMediaBridgeObjectsPage
}, options));
export default createMediaBridgeReferenceResolver();